export enum SignalServerURL {
  PROD = 'wwss://ws.voovmeeting.com/websocket/connection',
  TETS = 'wss://devws.voovmeeting.com/websocket/connection',
}

export const OverSeaAvatarUrl = 'https://meeting-1258344699.picsgp.myqcloud.com';
export const ChinaAvatarUrl = 'https://meeting-75420.picgzc.qpic.cn';

export const GUEST_APP_ID = '200000000';
